<template>
  <div>
    <div class="d-flex justify-content-between mb-3">
      <div class="font-weight-medium">
        <span v-if="selectable">Select </span>
        Payment Method
      </div>

      <b-button variant="link"
                class="p-0"
                @click="handleAddCard"
                v-if="paymentMethods.length > 0 && canAddPaymentMethod">Add Card
      </b-button>
    </div>

    <payment-method v-for="method in paymentMethods"
                    :payment-method="method"
                    :key="method.id"
                    :selectable="selectable"
                    :selected="selectedPaymentMethod === method"
                    :removable="removable"
                    @select="handleSelectPaymentMethod"
                    @remove="handleRemovePaymentMethod"/>

    <div class="d-flex flex-column align-items-center pt-2"
         v-if="paymentMethods.length === 0 && canAddPaymentMethod">
      <div>Payment methods you add will appear here</div>
      <div class="mb-3">
        <b-button variant="link" @click="handleAddCard">
          Add Payment Method
        </b-button>
      </div>

      <div class="d-flex">
        <b-img v-for="img in cardImages" :src="img" class="credit-card-avatar mr-1"/>
      </div>
    </div>

    <b-modal v-model="paymentMethodModal" title="Add Payment Method" hide-footer>
      <payment-method-form :organization="organization"
                           :payment-methods-url="paymentMethodsUrl"
                           @success="handleAddedPaymentMethod"
                           @cancel="paymentMethodModal = false"/>
    </b-modal>
  </div>
</template>

<script>
import GeneralMixins from "../../../mixins/GeneralMixins";
import PaymentMethod from "./PaymentMethod";
import AssetLoader from "../../../../AssetLoader";
import PaymentCardForm from "../Payments/PaymentCardForm";
import OrganizationBillingFormInputs from "../Billing/OrganizationBillingFormInputs";
import PaymentMethodForm from "./PaymentMethodForm.vue";

export default {
  components: {OrganizationBillingFormInputs, PaymentCardForm, PaymentMethod, PaymentMethodForm},
  props: {
    paymentMethodsUrl: {
      type: String,
      required: true
    },
    initialPaymentMethods: {
      type: Array,
      required: true
    },
    maxPaymentMethods: {
      type: Number,
      required: true
    },
    selectable: {
      type: Boolean,
      required: false,
      default: false
    },
    removable: {
      type: Boolean,
      required: false,
      default: true
    },
    selectedPaymentMethodId: {
      type: String,
      required: false,
      default: null
    },
    organization: {
      type: Object,
      required: true
    }
  },

  mixins: [GeneralMixins],

  data: function () {
    return {
      paymentMethods: this.initialPaymentMethods || [],
      paymentMethodModal: false,
      error: null,
      saving: false,
      selectedPaymentMethod: this.getPaymentMethod(this.selectedPaymentMethodId),
      stripeAddress: null,
      organizationAddress: null
    }
  },

  methods: {
    getPaymentMethod(id) {
      return this.initialPaymentMethods.find(p => p.stripe_id === id)
    },

    handleAddCard() {
      this.paymentMethodModal = true;
    },

    handleAddedPaymentMethod(paymentMethod) {
      this.$set(this.paymentMethods, this.paymentMethods.length, paymentMethod)
      this.paymentMethodModal = false
    },

    handleRemovePaymentMethod(paymentMethod) {
      this.$http.delete(`${this.paymentMethodsUrl}/${paymentMethod.id}`).then(fulfilled => {
        this.paymentMethods.splice(this.paymentMethods.indexOf(paymentMethod), 1)
        this.showToast("Payment method was removed")
        this.$emit('onRemove', paymentMethod)
      }, rejected => {
        this.showErrorToast("There was an error while removing this payment method");
      })
    },

    handleSelectPaymentMethod(paymentMethod) {
      if (this.selectable) {
        this.selectedPaymentMethod = paymentMethod
        this.$emit('onSelect', paymentMethod)
      }
    }
  },


  computed: {
    cardImages: function () {
      return AssetLoader.imagesInFolder("cards/")
    },

    canAddPaymentMethod: function () {
      return this.paymentMethods.length < this.maxPaymentMethods;
    }
  }
}
</script>
